import { parseState } from '../lib/payments';

export function isZipCodeValid(zip, countryCode) {
  const zipCode = `${zip}`;
  const zipLength = countryCode === 'US' ? 5 : 3;
  if (zipCode.length >= zipLength && /^[\w\-\s]+$/.test(zipCode)) {
    return true;
  }
  return false;
}

export function parseZipCode(zip, countryCode = '') {
  const zipCode = zip || '';
  const lowerCountryCode = countryCode.toLowerCase() || '';
  if (lowerCountryCode === 'ca') {
    return zipCode.substring(0, 3);
  }
  if (lowerCountryCode === 'au') {
    return zipCode.split(' ')[1] || zipCode;
  }
  if (lowerCountryCode === 'gb') {
    return zipCode.split(' ')[0];
  }
  return zipCode;
}

export function shouldValidateCode(promoCode) {
  if (!promoCode || typeof promoCode !== 'string') {
    return false;
  }
  const len = promoCode.length;
  if (len === 11) {
    const alphaPattern = /^[a-z]+$/i;
    const alphaNumPattern = /^[a-z0-9]+$/i;
    const numPattern = /^[0-9]+$/i;
    const firstTwo = alphaPattern.test(promoCode.substring(0, 2));
    const midThree = alphaNumPattern.test(promoCode.substring(2, 4));
    const lastSix = numPattern.test(promoCode.substring(5, 11));
    return firstTwo && midThree && lastSix;
  }
  return [16, 19, 24].includes(len);
}

export function parseRedeemCode(code) {
  const promoCode = code || '';
  return promoCode.toUpperCase().replace(new RegExp(' ', 'g'), '');
}

export function parseProfile(promoCode = '', fenderConnect = {}) {
  const parsedRedeemCode = parseRedeemCode(promoCode);
  const {
    email,
    firstName,
    lastName,
    subscriptions,
    productRatePlanId,
    productRatePlanSku,
    userID,
  } = fenderConnect;
  const { play } = subscriptions || {};
  return {
    email,
    firstName,
    lastName,
    redemptionCode: parsedRedeemCode,
    playSubscriptionStatus: play || 'unsubscribed',
    productRatePlanId,
    productRatePlanSku,
    productSku: process.env.REACT_APP_CLIENT_PLAY_PRODUCT_SKU,
    userID,
  };
}

export function parseZipResponse(zipResponse) {
  if (!zipResponse || !zipResponse.places) return {};
  const { country, places } = zipResponse;
  const place = places[0] || {};
  const { state } = place;
  return {
    city: place['place name'].split('(')[0].trim(),
    country,
    postalCode: zipResponse['post code'],
    state: parseState(state),
    stateAbbr: place['state abbreviation'],
  };
}
